import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { timer } from "rxjs";
import { UserService, LocalstorageService } from "../../../shared";
import { GMap } from "../bus-tracker-main-map/shared/gmap";
import { AddGeoFenceComponent } from "./add-geo-fence/add-geo-fence.component";
import { EditGeoFenceComponent } from "./edit-geo-fence/edit-geo-fence.component";
import { GeoFenceSideBarComponent } from "./geo-fence-side-bar/geo-fence-side-bar.component";
import { Hull } from "./shared/ConvexHull/hull";
import { DataService_BusTrackerGeoFenceMaintenance } from "./shared/data.service";
import { GeoFenceDeleteRequest } from "./shared/GeoFenceDeleteRequest";

@Component({
	selector: "app-bus-tracker-geo-fence-maintenance",
	templateUrl: "./bus-tracker-geo-fence-maintenance.component.html",
	styleUrls: ["./bus-tracker-geo-fence-maintenance.component.css"],
})
export class BusTrackerGeoFenceMaintenanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private mapService: DataService_BusTrackerGeoFenceMaintenance,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private localService: LocalstorageService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadPreferences();
	}

	/////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////

	user: any;
	hull: Hull = new Hull();

	@ViewChild(GMap)
	mapRef: GMap;

	@ViewChild(GeoFenceSideBarComponent)
	sideBarRef: GeoFenceSideBarComponent;

	lstGeoFence: any = [];
	lstSelectedGeoFences: any = [];
	FencesFromSelector: any = [];

	//
	// Options
	//

	ShowInfo: any = false;

	ShowExisting: any = true;
	HideInactive: any = true;
	HideUnselected: any = false;
	ShowNewPoints: any = true;
	ShowPreview: any = false;

	AdvancedMode: any = false;

	NewFenceColor: any = "#000";
	DefaultFenceColor: any = "#000";
	NewOpacity: any = 0.35;
	DefaultOpacity: any = 0.35;

	BrushModeID: any = 0;
	lstBrushMode: any = [
		{
			ID: 0,
			Desc: "Point",
		},
		{
			ID: 1,
			Desc: "Square Brush",
		},
		{
			ID: 2,
			Desc: "Octagon Brush",
		},
	];

	BrushSize: any = 0.05;
	DefaultBrushSize: any = 0.05;
	Concavity: any = 0;
	DefaultConcavity: any = 0;

	//
	// Built-In
	//
	ShowMap: any = false;
	MapPrefs: any;

	lstNewPoints: any[] = []; //For hiding new points
	overlays: any[] = []; //Displayed on Google maps

	options: any;
	ShowSideBar: any = false;
	InitStylesAndListeners: any = false;

	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////

	loadPreferences() {
		var result = this.mapService.BusMapPreferenceSelect(this.user.personID);
		result.subscribe(
			(response) => {
				this.MapPrefs = response[0];

				this.options = {
					center: {
						lat: Number(this.MapPrefs.DefaultLat),
						lng: Number(this.MapPrefs.DefaultLong),
					},
					zoom: Number(this.MapPrefs.DefaultZoom),
				};

				this.ShowMap = true;

				this.loadTopBarOptions();
			},
			(error) => {}
		);
	}

	loadTopBarOptions() {
		var GeoFence_MapOptions = this.localService.getItem("GeoFence_MapOptions");

		if (GeoFence_MapOptions != undefined) {
			this.ShowExisting = GeoFence_MapOptions.ShowExisting;
			this.HideInactive = GeoFence_MapOptions.HideInactive;
			this.HideUnselected = GeoFence_MapOptions.HideUnselected;
			this.ShowNewPoints = GeoFence_MapOptions.ShowNewPoints;
			this.ShowPreview = GeoFence_MapOptions.ShowPreview;
			this.NewFenceColor = GeoFence_MapOptions.NewFenceColor;
			this.NewOpacity = GeoFence_MapOptions.NewOpacity;
		}

		this.loadGeoFences();
	}

	loadGeoFences() {
		var result = this.mapService.GeoFenceSelectList();
		result.subscribe(
			(response) => {
				this.lstGeoFence = response;

				this.UpdateMapStylesAndListeners();
				this.UpdateOverlays();
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadGeoFences();
	}

	onClearPoints() {
		this.overlays = [];
		this.lstNewPoints = [];
	}

	onDeselectAll() {
		this.lstSelectedGeoFences = [];
		this.FencesFromSelector = [];

		this.UpdateOverlays();
	}

	onAdd() {
		if (this.CanAdd() == false) {
			return;
		}

		var ref = this.dialogService.open(AddGeoFenceComponent, {
			header: "Add Geo Fence",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				lstPoints: this.overlays,
				NewFenceColor: this.NewFenceColor,
				NewOpacity: this.NewOpacity,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.overlays = [];
				this.lstNewPoints = [];
				this.loadGeoFences();
			}
		});
	}

	onSearch() {
		this.ShowSideBar = !this.ShowSideBar;
	}

	onDelete() {
		this.errorMessage = "";

		var Count = this.lstSelectedGeoFences.length + this.FencesFromSelector.length;

		if (Count == 0) {
			this.errorMessage = "Select geo fences to delete (click on them or select one in the selector)";
			return;
		} else {
			var ConfirmMSG: any = "You are about to delete (or deactivate if it already has alerts) " + Count + " geo fence" + (Count != 1 ? "s" : "");
			ConfirmMSG + ". Do you want to continue?";

			this.confirmationService.confirm({
				key: "main",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: ConfirmMSG,
				header: "Confirm Delete",
				icon: "fa",
				accept: () => {
					this.FinishDelete();
				},
				reject: () => {},
			});
		}
	}

	FinishDelete() {
		//
		// Create Request
		//

		var lstIDs: number[] = [];

		for (var z = 0; z < this.lstSelectedGeoFences.length; z++) {
			var next = this.lstSelectedGeoFences[z];

			lstIDs = [...lstIDs, next.GeoFenceID];
		}

		for (var z = 0; z < this.FencesFromSelector.length; z++) {
			var next = this.FencesFromSelector[z];

			lstIDs = [...lstIDs, next.GeoFenceID];
		}

		let parms: GeoFenceDeleteRequest = {
			lstGeoFenceIDs: lstIDs,
		};

		//
		// Call SP
		//
		var result = this.mapService.GeoFenceDelete(parms);
		result.subscribe(
			(response) => {
				if (this.AllClear(response)) {
					this.loadGeoFences();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Geo Fences: " + response[0],
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onToggleInfo() {
		this.ShowInfo = !this.ShowInfo;
	}

	onResetNewFenceColor() {
		this.NewFenceColor = this.DefaultFenceColor;

		this.UpdateOverlays();
	}

	onResetNewOpacity() {
		this.NewOpacity = this.DefaultOpacity;

		this.UpdateOverlays();
	}

	onResetBrushSize() {
		this.BrushSize = this.DefaultBrushSize;
	}

	onResetConcavity() {
		this.Concavity = this.DefaultConcavity;
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////

	///////////////////////////////////
	//#region Selector
	///////////////////////////////////

	onSelectedChanged(val) {
		// console.log("Selected Changed");
		// console.log(val);

		this.FencesFromSelector = val;
		this.UpdateOverlays();
	}

	onCenterOn(val) {
		if (val.data != undefined) {
			this.mapRef.map.setCenter({
				lat: val.data.MidPointLat,
				lng: val.data.MidPointLong,
			});
		} else {
			this.mapRef.map.setCenter({
				lat: val.MidPointLat,
				lng: val.MidPointLong,
			});
		}
	}

	onEditGeoFence(val) {
		// console.log("Edit Geo Fence");
		// console.log(val);

		this.ShowExisting = false;
		this.HideUnselected = false;
		this.ShowNewPoints = true;
		this.ShowPreview = true;

		//
		// Info Window?
		// Clear current points?
		// Set show new points + preview?
		// You must press save to save "Geo Fence Desc"
		//

		//
		// Set Color Options
		//
		this.NewFenceColor = val.FillColor;
		this.NewOpacity = val.AlphaChannel;

		//
		// Create Markers
		//

		this.overlays = [];
		this.lstNewPoints = [];

		for (var z = 0; z < val.lstPoints.length; z++) {
			var next = val.lstPoints[z];

			this.lstNewPoints.push(
				new google.maps.Marker({
					position: { lat: next.Lat, lng: next.Long },
					draggable: true,
				})
			);
		}

		this.UpdateOverlays();

		// if(this.ShowNewPoints == true){
		//   this.lstNewPoints.forEach(e => {this.overlays = [...this.overlays, e]});

		//   if(this.ShowPreview == true && this.lstNewPoints.length >= 3){
		//     this.DrawPreviewPolygon();
		//   }
		// }
	}

	onSaveGeoFence(val) {
		// console.log("Save Geo Fence");
		// console.log(val);

		//
		// Check >= 3 points
		//

		//
		// Open Dialog
		//

		var ref = this.dialogService.open(EditGeoFenceComponent, {
			header: "Edit Geo Fence",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				lstPoints: this.overlays,
				NewFenceColor: this.NewFenceColor,
				NewOpacity: this.NewOpacity,
				GeoFence: val,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.sideBarRef.EditingID = -1;

				this.ShowExisting = true;
				this.HideUnselected = false;

				this.overlays = [];
				this.lstNewPoints = [];

				this.lstSelectedGeoFences = [];
				this.FencesFromSelector = [];

				this.loadGeoFences();
			}
		});
	}

	//#endregion
	///////////////////////////////////

	///////////////////////////////////
	//#region  Options
	///////////////////////////////////

	onShowExistingChange(val) {
		this.ShowExisting = val;

		this.UpdateOverlays();
		this.UpdatePreferences();
	}

	onHideInactiveChange(val) {
		this.HideInactive = val;

		this.UpdateOverlays();
		this.UpdatePreferences();
	}

	onHideUnselectedChange(val) {
		this.HideUnselected = val;

		this.UpdateOverlays();
		this.UpdatePreferences();
	}

	onShowNewPointsChange(val) {
		this.ShowNewPoints = val;

		this.UpdateOverlays();
		this.UpdatePreferences();
	}

	onShowPreviewChange(val) {
		this.ShowPreview = val;

		this.UpdateOverlays();
		this.UpdatePreferences();
	}

	onNewFenceColorChange(val) {
		this.NewFenceColor = val;

		this.UpdateOverlays();
		this.UpdatePreferences();
	}

	onNewOpacityChange(val) {
		this.NewOpacity = val;

		this.UpdateOverlays();
		this.UpdatePreferences();
	}

	//#endregion
	///////////////////////////////////

	///////////////////////////////////
	//#region  Creating New Points
	///////////////////////////////////

	handleMapClick(val) {
		if (this.BrushModeID == 0) {
			this.CreateMarker(val);
		} else if (this.BrushModeID == 1) {
			this.DrawSquareBrush(val);
		} else if (this.BrushModeID == 2) {
			this.DrawOctagonBrush(val);
		}
	}

	CreateMarker(clickEvent) {
		this.overlays = [];

		this.lstNewPoints.push(
			new google.maps.Marker({
				position: clickEvent.latLng,
				draggable: true,
			})
		);

		if (this.ShowNewPoints == true) {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}

		if (this.ShowPreview == true && this.lstNewPoints.length >= 3) {
			this.DrawPreviewPolygon();
		}
	}

	DrawSquareBrush(clickEvent) {
		this.overlays = [];

		//
		// Create 4 points
		//

		var Lat = clickEvent.latLng.lat();
		var Long = clickEvent.latLng.lng();

		//
		// Square
		//

		var latLng1 = new google.maps.LatLng({
			lat: Lat + this.BrushSize,
			lng: Long - this.BrushSize,
		});
		var latLng2 = new google.maps.LatLng({
			lat: Lat + this.BrushSize,
			lng: Long + this.BrushSize,
		});
		var latLng3 = new google.maps.LatLng({
			lat: Lat - this.BrushSize,
			lng: Long + this.BrushSize,
		});
		var latLng4 = new google.maps.LatLng({
			lat: Lat - this.BrushSize,
			lng: Long - this.BrushSize,
		});

		this.lstNewPoints.push(new google.maps.Marker({ position: latLng1, draggable: true }));
		this.lstNewPoints.push(new google.maps.Marker({ position: latLng2, draggable: true }));
		this.lstNewPoints.push(new google.maps.Marker({ position: latLng3, draggable: true }));
		this.lstNewPoints.push(new google.maps.Marker({ position: latLng4, draggable: true }));

		var PointSet: any = [];

		this.lstNewPoints.forEach((e) => {
			PointSet = [...PointSet, [e.position.lat(), e.position.lng()]];
		});

		var Polygon = this.hull.hull(PointSet, this.Concavity, undefined);

		this.lstNewPoints = [];

		for (var z = 0; z < Polygon.length; z++) {
			var next = Polygon[z];

			this.lstNewPoints.push(
				new google.maps.Marker({
					position: { lat: next[0], lng: next[1] },
					draggable: true,
				})
			);
		}

		if (this.ShowNewPoints == true) {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}

		if (this.ShowPreview == true && this.lstNewPoints.length >= 3) {
			this.DrawPreviewPolygon();
		}
	}

	DrawOctagonBrush(clickEvent) {
		this.overlays = [];

		//
		// Create 4 points
		//

		var Lat = clickEvent.latLng.lat();
		var Long = clickEvent.latLng.lng();

		//
		// Octagon Example
		//

		var Sides = 8;

		for (var z = 0; z < Sides; z++) {
			var nextLL = new google.maps.LatLng({
				// lat: Lat + Radius * Math.cos(z * 2 * Math.PI / Sides),
				// lng: Long + Radius * Math.sin(z * 2 * Math.PI / Sides)
				lat: Lat + this.BrushSize * Math.cos((z * 2 * Math.PI) / Sides),
				lng: Long + this.BrushSize * Math.sin((z * 2 * Math.PI) / Sides),
			});

			this.lstNewPoints.push(new google.maps.Marker({ position: nextLL, draggable: true }));
		}

		var PointSet: any = [];

		this.lstNewPoints.forEach((e) => {
			PointSet = [...PointSet, [e.position.lat(), e.position.lng()]];
		});

		var Polygon = this.hull.hull(PointSet, this.Concavity, undefined);

		this.lstNewPoints = [];

		for (var z = 0; z < Polygon.length; z++) {
			var next = Polygon[z];

			this.lstNewPoints.push(
				new google.maps.Marker({
					position: { lat: next[0], lng: next[1] },
					draggable: true,
				})
			);
		}

		if (this.ShowNewPoints == true) {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}
		if (this.ShowPreview == true && this.lstNewPoints.length >= 3) {
			this.DrawPreviewPolygon();
		}
	}

	handleOverlayClick(val) {
		this.RemoveMarker(val);
	}

	RemoveMarker(clickEvent) {
		for (var z = 0; z < this.lstNewPoints.length; z++) {
			var next = this.lstNewPoints[z];

			if (next == clickEvent.overlay) {
				this.lstNewPoints.splice(z, 1);
				break;
			}
		}

		this.overlays = [];

		if (this.ShowNewPoints == true) {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}
		if (this.ShowPreview == true && this.lstNewPoints.length >= 3) {
			this.DrawPreviewPolygon();
		}
	}

	onOverlayDragEnd(val) {
		this.overlays = [];

		if (this.ShowNewPoints == true) {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}
		if (this.ShowPreview == true && this.lstNewPoints.length >= 3) {
			this.DrawPreviewPolygon();
		}
	}

	//#endregion
	///////////////////////////////////

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////

	CanAdd() {
		if (this.lstNewPoints.length < 3) {
			return false;
		} else {
			return true;
		}
	}

	UpdateOverlays() {
		//
		// New Points
		//
		this.overlays = [];
		if (this.ShowNewPoints == true) {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}
		if (this.ShowPreview == true && this.lstNewPoints.length >= 3) {
			this.DrawPreviewPolygon();
		}

		//
		// Geo Fences from DB
		//
		this.mapRef.map.data.forEach((element) => {
			this.mapRef.map.data.remove(element);
		});

		if (this.ShowExisting == true) {
			for (var z = 0; z < this.lstGeoFence.length; z++) {
				var next = this.lstGeoFence[z];

				this.DrawPolygonFromFence(next);
			}
		}
	}

	DrawPreviewPolygon() {
		//
		// Create Path from overlays
		// NOTE: Overlays array only has NEW points
		// Existing data is only on data layer
		//
		var lstLatLng: google.maps.LatLng[] = [];

		for (var z = 0; z < this.lstNewPoints.length; z++) {
			var next = this.lstNewPoints[z];

			lstLatLng = [...lstLatLng, new google.maps.LatLng(next.position.lat(), next.position.lng())];
		}

		//
		// Add Polygon
		//
		var poly = new google.maps.Polygon({
			paths: [lstLatLng],
			strokeOpacity: 0.5,
			strokeWeight: 1,
			fillColor: this.NewFenceColor,
			fillOpacity: this.NewOpacity,
		});

		this.overlays.push(poly);
	}

	DrawPolygonFromFence(GeoFenceInfo) {
		//
		// Check Active
		//
		if (this.HideInactive == true && GeoFenceInfo.Active == false) {
			return;
		}

		//
		// Check Selected
		//

		var AlreadySelected = false;
		for (var z = 0; z < this.lstSelectedGeoFences.length; z++) {
			var next = this.lstSelectedGeoFences[z];

			if (next.GeoFenceID == GeoFenceInfo.GeoFenceID) {
				AlreadySelected = true;
				break;
			}
		}

		var FromSelector = false;
		// if(AlreadySelected == false && this.ShowSideBar == true){
		if (AlreadySelected == false) {
			for (var z = 0; z < this.FencesFromSelector.length; z++) {
				var next = this.FencesFromSelector[z];

				if (GeoFenceInfo.GeoFenceID == next.GeoFenceID) {
					FromSelector = true;
					break;
				}
			}
		}

		//
		// Hide Unselected fences?
		//
		if (this.HideUnselected == true && !(AlreadySelected || FromSelector)) {
			return;
		}

		let FenceLabel: any = "";

		FenceLabel = GeoFenceInfo.GeoFenceDesc;

		var lstLatLong: google.maps.LatLng[] = [];

		for (var z = 0; z < GeoFenceInfo.lstPoints.length; z++) {
			var next = GeoFenceInfo.lstPoints[z];

			lstLatLong = [...lstLatLong, new google.maps.LatLng({ lat: next.Lat, lng: next.Long })];
		}

		let FencePolygon: google.maps.Data.Polygon = new google.maps.Data.Polygon([lstLatLong]);

		let FenceFeatureOptions: google.maps.Data.FeatureOptions = {
			geometry: FencePolygon,
			properties: {
				Type: "GeoFence",
				Label: FenceLabel,
				GeoFenceID: GeoFenceInfo.GeoFenceID,
				GeoFenceDesc: GeoFenceInfo.GeoFenceDesc,
				BusDesc: GeoFenceInfo.BusDesc,
				FillColor: GeoFenceInfo.FillColor,
				AlphaChannel: GeoFenceInfo.AlphaChannel,
				BusID: GeoFenceInfo.BusID,
				GeofenceTriggerTypeID: GeoFenceInfo.GeofenceTriggerTypeID,
				GeofenceTriggerTypeCD: GeoFenceInfo.GeofenceTriggerTypeCD,
				GeofenceTriggerTypeDesc: GeoFenceInfo.GeofenceTriggerTypeDesc,
				Severity: GeoFenceInfo.Severity,
				SeverityDesc: GeoFenceInfo.SeverityDesc,
				AlertComments: GeoFenceInfo.AlertComments,
				Active: GeoFenceInfo.Active,
				ActiveDesc: GeoFenceInfo.ActiveDesc,
				MidPointLat: GeoFenceInfo.MidPointLat,
				MidPointLong: GeoFenceInfo.MidPointLong,
				lstPoints: GeoFenceInfo.lstPoints,
				Selected: AlreadySelected || FromSelector,
			},
		};

		let FenceFeature: google.maps.Data.Feature = new google.maps.Data.Feature(FenceFeatureOptions);
		this.mapRef.map.data.add(FenceFeature);
	}

	GetRandomColor() {
		var r = Math.random() * 255;
		var g = Math.random() * 255;
		var b = Math.random() * 255;

		return "rgb(" + r + "," + g + "," + b + ")";
		// return '#42A5F5';
	}

	UpdateMapStylesAndListeners() {
		//
		// Only Run 1 time
		//
		if (this.InitStylesAndListeners == true) {
			return;
		}

		this.InitStylesAndListeners = true;

		/////////////////////////////////////////////////////
		// Styling
		/////////////////////////////////////////////////////

		this.mapRef.map.data.setStyle(function (feature) {
			var Type = feature.getProperty("Type");

			if (Type == "GeoFence") {
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("Label");
				// var NextColor: any = feature.getProperty("FillColor");

				nextLabel = {
					text: NextText,
					color: "Black", //NextColor,
					fontWeight: "Bold",
				};

				var NextStrokeColor: any = "Black";
				var NextStrokeWeight: any = 1;

				if (feature.getProperty("Selected") == true) {
					NextStrokeColor = "Blue";
					NextStrokeWeight = 4;
				}

				if (NextText != "") {
					return {
						label: nextLabel,
						title: feature.getProperty("GeoFenceID"),
						strokeOpacity: 0.5,
						strokeColor: NextStrokeColor,
						strokeWeight: NextStrokeWeight,
						fillColor: feature.getProperty("FillColor"),
						fillOpacity: feature.getProperty("AlphaChannel"),
					};
				} else {
					return {
						title: feature.getProperty("GeoFenceID"),
						strokeOpacity: 0.5,
						strokeColor: NextStrokeColor,
						strokeWeight: NextStrokeWeight,
						fillColor: feature.getProperty("FillColor"),
						fillOpacity: feature.getProperty("AlphaChannel"),
					};
				}
			}
		});

		/////////////////////////////////////////////////////

		/////////////////////////////////////////////////////
		// Event Listeners
		/////////////////////////////////////////////////////

		this.mapRef.map.data.addListener("rightclick", (event) => {
			/////////////////////////////////////////////////////////////////////////////////////////////////////
			// Open Info Window
			/////////////////////////////////////////////////////////////////////////////////////////////////////

			let infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow();

			var type: any = event.feature.getProperty("Type");
			if (type == "GeoFence") {
				infoWindow.setContent(this.GetGeoFencePopup(event.feature));
			}

			infoWindow.setOptions({
				position: {
					lat: event.feature.getProperty("MidPointLat"),
					lng: event.feature.getProperty("MidPointLong"),
				},
			});

			infoWindow.open(this.mapRef.map);

			/////////////////////////////////////////////////////////////////////////////////////////////////////
		});

		this.mapRef.map.data.addListener("click", (event) => {
			if (event.feature.getProperty("Type") == "GeoFence") {
				/////////////////////////////////////////////////////////////////////////////////////////////////////
				// Select or deselect GeoFence
				/////////////////////////////////////////////////////////////////////////////////////////////////////

				var tempSelected = event.feature.getProperty("Selected");

				var NewSelected = true;
				if (tempSelected == true) {
					NewSelected = false;
				}

				event.feature.setProperty("Selected", NewSelected);

				var GeoFenceID = event.feature.getProperty("GeoFenceID");

				if (NewSelected == true) {
					for (var z = 0; z < this.lstGeoFence.length; z++) {
						var next = this.lstGeoFence[z];

						if (next.GeoFenceID == GeoFenceID) {
							this.lstSelectedGeoFences = [...this.lstSelectedGeoFences, next];
							break;
						}
					}

					// this.mapRef.map.setCenter( { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") } );
				} else {
					this.lstSelectedGeoFences = this.lstSelectedGeoFences.filter((fence) => fence.GeoFenceID != GeoFenceID);
				}

				/////////////////////////////////////////////////////////////////////////////////////////////////////
			}
		});

		/////////////////////////////////////////////////////
	}

	GetGeoFencePopup(GeoFenceInfo) {
		var htmlText: any = "";

		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
        
        <label style="margin: 0px;">Description:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeoFenceDesc") +
			`</p>

        <label style="margin: 0px;">Used By:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Trigger Type Code:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeofenceTriggerTypeCD") +
			`</p>

        <label style="margin: 0px;">Trigger Type Description:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeofenceTriggerTypeDesc") +
			`</p>

        <label style="margin: 0px;">Severity:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("SeverityDesc") +
			`</p>

        <label style="margin: 0px;">Comments:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("AlertComments") +
			`</p>

        <label style="margin: 0px;">Active:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("ActiveDesc") +
			`</p>

      </div>
    `;

		return htmlText;
	}

	UpdatePreferences() {
		let GeoFence_MapOptions: any = {
			ShowExisting: this.ShowExisting,
			HideInactive: this.HideInactive,
			HideUnselected: this.HideUnselected,
			ShowNewPoints: this.ShowNewPoints,
			ShowPreview: this.ShowPreview,
			NewFenceColor: this.NewFenceColor,
			NewOpacity: this.NewOpacity,
		};

		this.localService.setItem("GeoFence_MapOptions", GeoFence_MapOptions);
	}

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	/////////////////////////////////////////////////////////////////////////
}
